module.exports = __webpack_public_path__ + "static/img/saimenInstallForWin_pic5.ef2fcfb.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/saimenInstallForWin/saimenInstallForWin_pic5.png
// module id = 588
// module chunks = 1